import React from "react";
import FilmalityCircularProgress from "../../../shared/filmality-circular-progress";
import Character from "./character";
import Actor from "./actor";
import Errors from "../../../shared/errors";
import HelpText from "../../../shared/help-text";
import { OnboardingStep1ClassName } from './ducks/reducer';

function Overview(props) {
  const {
    overview,
    filmId,
    charactersAssignedPercentage,
    assignActor,
    unassignActor,
    aliasCharacter,
    unaliasCharacter,
    errors,
    warnings
  } = props;

  const readOnly = overview.readOnly;

  return (
    <div>
      <div className="columns">
        <div className="circular-progress column is-one-quarter">
          <FilmalityCircularProgress
            percentage={charactersAssignedPercentage}
            title="Background Characters Assigned"
          />
        </div>
      </div>
      {errors && <Errors errors={errors} />}
      {warnings && <Errors errors={warnings} isWarning={true} />}
      <div className="columns">
        <div className="column">
          <table className="table">
            <thead>
              <tr>
                <th>Background Character</th>
                <th>No.</th>
                <th>Background Actor</th>
                <th>Mandy Url</th>
                <th>Starnow Url</th>
              </tr>
            </thead>
            <tbody>
              {(overview.backgroundCharacters || []).map((character, index) => {
                return (
                  <Character
                    key={index}
                    index={index}
                    character={character}
                    filmId={filmId}
                    assignActor={assignActor}
                    unassignActor={unassignActor}
                    aliasCharacter={aliasCharacter}
                    unaliasCharacter={unaliasCharacter}
                    readOnly={readOnly}
                    canAccessBackgroundActors={overview.canAccessBackgroundActors}></Character>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="column is-narrow">
          {!readOnly && <table className={`${OnboardingStep1ClassName} table sticky`}>
            <thead>
              <tr>
                <th>Background Actor</th>
              </tr>
            </thead>
            <tbody>
              {(overview.backgroundActors || []).map((actor, index) => {
                return (
                  <Actor
                    key={index}
                    actor={actor}
                    index={index}
                    filmId={filmId}
                    readOnly={readOnly}></Actor>
                );
              })}
            </tbody>
          </table>}
        </div>
      </div>
    </div>
  );
}

export default Overview;
